<template>
   <header id="page-topbar">
      <div class="navbar-header">
         <div class="d-flex">
            <div class="navbar-brand-box">
               <router-link tag="a" to="/" class="logo logo-light">
                  <span class="logo-sm">
                     <img src="@/assets/images/logo-asein-light-sm.png" alt height="38" />
                  </span>
                  <span class="logo-lg">
                     <img src="@/assets/images/logo-asein-light.png" alt />
                  </span>
               </router-link>
            </div>

            <button id="vertical-menu-btn" type="button" class="btn btn-sm px-3 font-size-16 header-item" @click="toggleMenu">
               <i class="fa fa-fw fa-bars"></i>
            </button>

            <b-dropdown  v-if="zones.length > 1" variant="black" class="d-lg-block" toggle-class="header-item" menu-class="p-3">
               <template v-slot:button-content>
                  Zona Seleccionada: {{ selectedZone }}
                  <i class="mdi mdi-chevron-down"></i>
               </template>

               <div class="row">
                  <div class="col-sm-8">
                     <div class="row">
                        <div class="col-md-4">
                           <ul class="list-unstyled">
                              <li v-for="(zone, index) in zones" :key="index" class="py-3" style="width: 40px;">
                                 <a href="javascript:void(0)" @click="changeZone(index)">{{ zone }}</a>
                              </li>
                           </ul>
                        </div>
                     </div>
                  </div>
               </div>
            </b-dropdown>
         </div>

         <div class="d-flex">
            <b-dropdown class="d-none d-lg-inline-block noti-icon" menu-class="dropdown-menu-lg" right toggle-class="header-item" variant="black">
               <template v-slot:button-content>
                  <i class="bx bx-customize"></i>
               </template>

               <div class="px-lg-2">
                  <div class="row no-gutters">
                     <div class="col">
                        <a class="dropdown-icon-item" href="http://intranet.asein.es" target="_blank">
                           <img src="@/assets/images/brands/google-sites.png" alt="Logo Google Sites" />
                           <span>Intranet ASEIN</span>
                        </a>
                     </div>
                     <div class="col">
                        <a class="dropdown-icon-item" href="http://www.asein.es" target="_blank">
                           <img src="@/assets/images/brands/www.png" alt="Logo www" />
                           <span>Web ASEIN</span>
                        </a>
                     </div>
                  </div>
               </div>
            </b-dropdown>

            <div class="dropdown d-none d-lg-inline-block ml-1">
               <button type="button" class="btn header-item noti-icon" @click="initFullScreen">
                  <i class="bx bx-fullscreen"></i>
               </button>
            </div>

            <b-dropdown right variant="black" toggle-class="header-item">
               <template v-slot:button-content>
                  <img class="rounded-circle header-profile-user" src="@/assets/images/users/avatar-1.jpg" alt="Header Avatar"/>
                  <span class="d-none d-xl-inline-block ml-1">{{ fullname }}</span>
                  <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
               </template>
               <!-- item-->
               <b-dropdown-item>
                  <router-link tag="span" to="/mis-datos">
                     <i class="bx bx-user font-size-16 align-middle mr-1"></i> Mis Datos
                  </router-link>
               </b-dropdown-item>
               <b-dropdown-divider></b-dropdown-divider>
               <a href="javascript:void(0)" @click="logout()" class="dropdown-item text-danger">
                  <i class="bx bx-power-off font-size-16 align-middle mr-1 text-danger"></i> Logout
               </a>
            </b-dropdown>
         </div>
      </div>
   </header>
</template>

<script>
   import { authMethods } from "@/services/helpers"
   export default {
      methods: {
         toggleMenu() {
            this.$parent.toggleMenu();
         },
         toggleRightSidebar() {
            this.$parent.toggleRightSidebar();
         },
         initFullScreen() {
            document.body.classList.toggle("fullscreen-enable");
            if (!document.fullscreenElement && /* alternative standard method */ !document.mozFullScreenElement && !document.webkitFullscreenElement) {
               // current working methods
               if (document.documentElement.requestFullscreen) {
                  document.documentElement.requestFullscreen();
               } else if (document.documentElement.mozRequestFullScreen) {
                  document.documentElement.mozRequestFullScreen();
               } else if (document.documentElement.webkitRequestFullscreen) {
                  document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
               }
            } else {
               if (document.cancelFullScreen) {
                  document.cancelFullScreen();
               } else if (document.mozCancelFullScreen) {
                  document.mozCancelFullScreen();
               } else if (document.webkitCancelFullScreen) {
                  document.webkitCancelFullScreen();
               }
            }
         },
         logout() {
            this.$store.dispatch('logout')
            this.$router.push('/login')
         },
         changeZone(index) {
            this.$store.commit('change_zone', index)
         }
      },
      computed: {
         fullname() {
            return this.$store.state.user.fullname
         },
         selectedZone() {
            return this.$store.state.user.selectedZone
         },
         zones() {
            return this.$store.state.user.zones
         }
      },
      components: { ...authMethods }
   };
</script>

<style scoped>
   .navbar-brand-box {
      padding: 0;
   }
</style>